module.exports = __webpack_public_path__ + "static/media/headphones.51e853d6.jpg";